import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import io from "socket.io-client";

window.Event = new (class {
  constructor() {
    this.vue = new Vue();
  }

  fire(event, data = null) {
    this.vue.$emit(event, data);
  }

  listen(event, callback) {
    this.vue.$on(event, callback);
  }
})();

new Vue({
  computed: {
    ...mapGetters(["userData"]),
  },
  created() {
    if (window.location.pathname.startsWith("/good/")) {
      return;
    }
    /**
     * assets/config 을 읽어 온다.
     * 아직 vue 객체가 초기화된 상태가 아니기에 store에 저장하지는 않는다.
     */

    if (process.env.NODE_ENV !== "development") {
      axios.get("/assets/config.json").then((res) => {
        this.connectWebSocket(res.data.websocket_port);
      });
    } else {
      this.connectWebSocket(5000);
    }
  },
  methods: {
    ...mapActions(["saveLocalDb", "deleteLocalDb"]),
    connectWebSocket(port) {
      let location = window.location;
      let origin = location.protocol + "//" + location.hostname + ":" + port;
      const socket = io(origin, { transports: ["websocket"] });
      socket.on("connect", function() {
        console.info("socket was connected");
        this.emit("send", "I was connected");
      });
      socket.on("broadcast", function(data) {
        // 모든 client에게 알리는 내용을 수신
        // 상황에 따라서 Message를 표시해야 할 수도.
        console.info("broadcast", data);
      });
      socket.on("base_data", function(data) {
        //base data의 변경을 수신
        Event.fire("received", data);
      });
      Event.listen(
        "received",
        function(data) {
          this.processBaseData(data);
        }.bind(this)
      );
    },
    processBaseData(param) {
      let table = "table_" + param.class.toLowerCase();
      if (param.type === "D") {
        this.deleteLocalDb({ table: table, data: param.data });
      } else {
        if (table === "table_notice") {
          //공지사항인 경우 자신의 부서/그룹에 해당하는지 확인
          let notice = param.data;
          let user = this.userData;

          if (
            notice.branch_all_flag !== "Y" &&
            notice.user_group_all_flag !== "Y"
          ) {
            let is_target = false;
            if (notice.branch_all_flag !== "Y") {
              is_target = notice.branch_ids.includes(user.branch_id);
            }
            if (!is_target && notice.user_group_all_flag !== "Y") {
              is_target = notice.user_group_ids.includes(user.user_group_id);
            }
            if (!is_target) {
              //대상이 아닌 경우 기존에는 대상일 수 있으니 삭제한다.
              param.type = "D";
              this.deleteLocalDb({ table: table, data: notice.id });
            } else {
              this.saveLocalDb({ table: table, data: param.data });
            }
          } else {
            this.saveLocalDb({ table: table, data: param.data });
          }
        } else {
          if (Array.isArray(param.data)) {
            param.data.map((d) => {
              this.saveLocalDb({ table: table, data: d });
            });
          } else {
            this.saveLocalDb({ table: table, data: param.data });
          }
        }
      }
      this.EventBus.$emit("changedBaseData", {
        table: table,
        type: param.type,
        data: param.data,
      });
    },
  },
});

export const SocketIO = {
  // install(Vue) {
  //     Vue.mixin({});
  // Vue.prototype.sendSocket = (message) => {
  //     socket.emit('send', message);
  // };
  // Vue.prototype.socket = socket;
  // }
};
